const DISPLAY_COPY = {
  headerFrom: '保存状态',
  headerTo: '语义状态',
  rowTo: '兼容展示'
}

const FAIL_CLOSED_CLASS = 'first-book-semantics-fail-closed'

function toggleSection(vm, selector, visible) {
  const node = vm.$el.querySelector(selector)
  if (node) node.style.display = visible ? '' : 'none'
}

function applyFirstBookFailClosed(vm) {
  const parentScope = (vm.$parent && vm.$parent.analysisScope) || {}
  const expectedTotal = Number(parentScope.stock_total_count)
  const expectedFormal = Number(parentScope.formal_count)
  const expectedTemp = Number(parentScope.temp_count)
  const actualTotal = Number(vm.totalCount || 0)
  const shouldMask = Number.isFinite(expectedTotal) && expectedTotal > 0 && actualTotal === 0 && vm.loading !== true

  let notice = vm.$el.querySelector(`.${FAIL_CLOSED_CLASS}`)
  if (shouldMask) {
    if (!notice) {
      notice = document.createElement('div')
      notice.className = FAIL_CLOSED_CLASS
      notice.style.cssText = 'margin:0 0 16px;padding:12px 14px;border:1px solid #f5dab1;border-radius:8px;background:#fdf6ec;color:#b88230;font-size:13px;line-height:1.6;'
      const firstAlert = vm.$el.querySelector('.page-alert')
      if (firstAlert && firstAlert.parentNode) firstAlert.parentNode.insertBefore(notice, firstAlert.nextSibling)
      else vm.$el.insertBefore(notice, vm.$el.firstChild)
    }
    notice.textContent = `成员详情暂不可确认。当前第一本账范围仍为：正式区 ${Number.isFinite(expectedFormal) ? expectedFormal : '—'} 只、临时区 ${Number.isFinite(expectedTemp) ? expectedTemp : '—'} 只、合计 ${expectedTotal} 只；详情读取失败不会显示成 0。`
    toggleSection(vm, '.summary-row', false)
    toggleSection(vm, '.toolbar-card', false)
    const tabs = vm.$el.querySelector('.el-tabs')
    if (tabs) {
      const card = tabs.closest('.el-card')
      if (card) card.style.display = 'none'
    }
    return
  }

  if (notice && notice.parentNode) notice.parentNode.removeChild(notice)
  toggleSection(vm, '.summary-row', true)
  toggleSection(vm, '.toolbar-card', true)
  const tabs = vm.$el.querySelector('.el-tabs')
  if (tabs) {
    const card = tabs.closest('.el-card')
    if (card) card.style.display = ''
  }
}

function applyFirstBookSemanticsCopy(vm) {
  if (!vm || !vm.$el || vm.$options.name !== 'FirstBookSemantics') return

  vm.$el.querySelectorAll('th .cell').forEach(node => {
    if (node.textContent.trim() === DISPLAY_COPY.headerFrom) {
      node.textContent = DISPLAY_COPY.headerTo
    }
  })

  vm.$el.querySelectorAll('.saved-text').forEach(node => {
    node.textContent = DISPLAY_COPY.rowTo
  })

  applyFirstBookFailClosed(vm)
}

export default {
  install(Vue) {
    Vue.mixin({
      mounted() {
        this.$nextTick(() => applyFirstBookSemanticsCopy(this))
      },
      updated() {
        this.$nextTick(() => applyFirstBookSemanticsCopy(this))
      }
    })
  }
}
